import { api_POST } from "./_axios.js";

const painel_api = {
    postSituacaoPorContrato: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`painel/SituacaoPorContrato`, json_submit).then(result => {
                resolve(result)
            });
        });
        return promise;
    },
}

export default painel_api
